import constants from '@/libs/constant/constants'
import {deleteDonationTier, getDonationTier, updateDonationTier, createDonationTier, createDonationSet, getStripeAccountDetail, removeDonationSet, getDomainList, updateDonationSet} from '@/libs/api/api'
import {loader, logout, errorHandler, message} from '@/libs/helper'
import {isEmpty, find, filter} from 'lodash'
import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue'
import { mapGetters } from 'vuex'
import permissions from '@/libs/constant/permissions'

export default {
    name: 'DonationsPage',
    components: {
        SettingsDropdown
    },
    props: {
        selectedValue: {
            type: Object,
            default: () => {}
        },
        accountStatus: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            isEmpty,
            name: '',
            payoutAccount: '',
            selectedPayoutAccount: {},
            selectedUsedFor: {},
            usedFor: '',
            currentPage: 1,
            currencyOptions: [
                {label:'Dollar', value: constants.DONATION_CURRENCY.DOLLAR}, 
                {label:'Euro', value: constants.DONATION_CURRENCY.EURO}
            ],
            payoutOptions: [],
            showDialog: false,
            selectedTier: constants.DONATION_TIERS.MONTHLY_TIER,
            tierInformation: {},
            selectedSearchValue: '',
            searchValue: '',
            tier: {
                eur_amount: 0,
                usd_amount: 0,
                description: '',
            },
            addSet: false,
            isFetchingSets: false,
            isEdit: false,
            isEditSet: false,
            skip: 0,
            limit: 30,
            sort: 'name',
            order: 'desc',
            // columns: ['name', 'currency', 'payout_account', 'used_for', 'status', 'settings'],
            columns:['name','payout_account', 'used_for', 'status', 'settings'],
            tableSettings: {
                headings: {
                  name: 'Name',
                //   currency: 'Currency',
                  payout_account: 'Payout account',
                  used_for: 'Use for',
                  status: 'Status',
                  settings: '' 
                },
                pagination: { show: true},
                perPage: 30,
                filterable: [],
                filterByColumn: true,
                sortable: ['no']
            },
            settingOptions:[
                {command: 'EDIT_SET', label: 'Edit'},
                {command: 'DUPLICATE_SET', label: 'Duplicate'},
                {command: 'REMOVE_SET', label: 'Remove', isDelete: true}
            ],
            donationSet: {},
            usedForOptions: [],
            loading:false,
            searchedtierInformation:[],
            tierInformationTemp:[],
            permissions: permissions
        }
    },
    computed: {
        ...mapGetters(['hasPermission']),
        // usedforOptions () {
        //     if (!isEmpty(this.selectedValue)) {
                
        //     }
        //     return []
        // },
        setsList () {
            if (!isEmpty(this.tierInformation)) {
                return [{...this.tierInformation}]
            }
            return []
        }
    },
    watch: {
        accountStatus () {
            this.fetchStripeAccountDetail()
        },
        selectedValue () {
            this.fetchData()
        }
    },
    created () {
        this.monthlyTier = constants.DONATION_TIERS.MONTHLY_TIER
        this.oneTimeTier = constants.DONATION_TIERS.ONE_TIME_TIER
        this.euroCurrency = constants.DONATION_CURRENCY.EURO
    },
   async beforeMount() {
        await this.fetchData()
    },
    methods: {
        async fetchData () {
            this.loading=true
            await this.fetchDonatioTiersList()
            await this.fetchStripeAccountDetail()
            await this.fetchUsedForOptions()
            this.loading=false
        },
        /**
         * close dialog
         */
        closeDialog () {
            this.showDialog = false
            this.isEdit = false
            this.tier = {
                usd_amount: 0,
                eur_amount: 0,
                description: ''
            }
        },
        changeTier (tier) {
            this.selectedTier = tier
        },
        /**
         * fetch the tier list
         */
        async fetchDonatioTiersList () {
            if(!this.hasPermission(permissions.getDonationTier)) return;
            try {
                // body for api
                let body = {
                    entity_type: this.$route.params.type && this.$route.params.type.toUpperCase(),
                    entity_id: this.$route.params.id,
                    only_active: false
                }
                // api call
                let response = await getDonationTier(body)
                this.tierInformation = (response && response[0] )|| {}
                this.setTierValues()
            } catch (error) {
              console.error(error)  
            }
        },

        /** set tier values */
        setTierValues () {
            this.name = (this.tierInformation && this.tierInformation.name )|| ''
            this.payoutAccount = (this.tierInformation && this.tierInformation.payout_account) || ''
            this.usedFor = (this.tierInformation && this.tierInformation.used_for) || ''

        },

        /**
         * to creat the donation tier
         */
        createNewDonationTier (isDraft) {
            // loader(this, true)
            // body for api
            let body = {
                set_id: this.tierInformation._id
            }

            // tier object to be send in body
            let tier = {description: this.tier.description, eur_amount: this.tier.eur_amount.toString(), usd_amount: this.tier.usd_amount.toString(), in_draft: isDraft}

            // monthly tier
            if (this.selectedTier === this.monthlyTier) body.monthly_tier = tier
            // one time tier
            else body.one_time_tier = tier

            // api call
            createDonationTier(body)
            .then(response => {
                // response update
                this.tierInformation = response.result || {}
                // success message
                message(this, constants.messageType.SUCCESS, 'Tier created successfully')
                // close dialog
                this.closeDialog()
            })
            .catch(error => {
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }).finally(() => {
                loader(this, false)
                this.addSet=!this.addSet;
            })
        },
        /**
         * disable button
         */
        disablePublishButton () {
            if (this.tier.eur_amount === 0 || this.tier.usd_amount === 0 || this.tier.description === '') return true
            return false
        },
        /**
         * to update the tier
         */
        async editDonationTier () {
            try {
                loader(this, true)
                // body for api call
                let body = {...this.tier, tier_id: this.tier._id, eur_amount: this.tier.eur_amount.toString(), usd_amount: this.tier.usd_amount.toString(), tier_type: this.selectedTier}
                delete body.createdAt
                delete body.updatedAt
                delete body._id
                // api call
            let response = await updateDonationTier(body)
            if (response.success) {
                    let tierInformation = {...this.tierInformation}
                    // if monthly tier
                    if (this.selectedTier === this.monthlyTier) {
                        tierInformation.monthly_tier = tierInformation.monthly_tier.map(tier => {
                            if (tier._id === this.tier._id) {
                                tier = this.tier
                            }
                            return tier
                        })
                    } else {
                        tierInformation.one_time_tier = tierInformation.one_time_tier.map(tier => {
                            if (tier._id === this.tier._id) {
                                tier = this.tier
                            }
                            return tier
                        })
                    }
                    this.tierInformation = tierInformation
                    // success message
                    message(this, constants.messageType.SUCCESS, 'Tier updated successfully')
                    this.closeDialog()
                }
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
            loader(this, false)
        },
        /**
         * remove donation tier
         */
        async removeDonationTier () {
            try {
                loader(this, true)
                // body for api
                let body = {
                    tier_id: this.tier._id,
                    document_id: this.tierInformation._id,
                    tier_name: this.selectedTier
                }
                let response = await deleteDonationTier(body)
                if (response.success) {
                    let tierInformation = {...this.tierInformation}
                    // if monthly tier
                    if (this.selectedTier === this.monthlyTier) {
                        tierInformation.monthly_tier = tierInformation.monthly_tier.filter(tier => tier._id !== this.tier._id)
                    } else {
                        tierInformation.one_time_tier = tierInformation.one_time_tier.filter(tier => tier._id !== this.tier._id)
                    }
                    this.tierInformation = tierInformation
                    // success message
                    message(this, constants.messageType.SUCCESS, 'Tier deleted successfully')
                    this.closeDialog()
                }
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))   
            }
            loader(this, false)
        },
        updateTierInformation (tierInformation) {
            
            return tierInformation
        },
        openEditPopup (tier) {
            this.tier = {...tier}
            this.isEdit = true
            this.showDialog = true
        },
        /**
         * to fetch the stripe account detail
         */
         async fetchStripeAccountDetail () {
            if(!this.hasPermission(permissions.getStripeAccountDetail)) return;
            // if (this.accountStatus && this.accountStatus.details_submitted) {
                // body for api
                let body = {
                    entity_id: this.$route.params.id,
                    entity_type: this.$route.params.type && this.$route.params.type.toUpperCase()
                }
                // api call
               await  getStripeAccountDetail(body)
                .then(response => {
                    this.payoutOptions = [{...response.result, ...response.balance}]
                    this.tierInformation={...this.tierInformation , signal:response.result.signal}
                })
            // }    
        },

        /**
         * open tier popup
         * @returns 
         */
        async openTierPopup () {
            try {
                if (isEmpty(this.tierInformation._id)) {
                    if (this.name === '' || this.usedFor === '' || this.payoutAccount === '') {
                        message(this, constants.messageType.ERROR, 'Please enter all the above fields')
                        return
                    }
                    let body = {
                        entity_type: this.$route.params.type.toUpperCase(),
                        entity_id: this.$route.params.id,
                        name: this.name,
                        payout_account: {
                            name: this.selectedPayoutAccount.display_name,
                            account_id: this.selectedPayoutAccount.id
                        },
                        used_for: {
                            used_for_id: (this.selectedUsedFor.id || this.selectedUsedFor._id),
                            name: (this.selectedUsedFor.screen_name || this.selectedUsedFor.name || this.selectedUsedFor.first_name)
                        }
                    }
                    loader(this, true)
                    this.tierInformation = await createDonationSet(body)
                    this.setTierValues()
                }
                this.showDialog = !this.showDialog
            } catch (error) {
                console.error(error)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
            finally {
                loader(this, false)
            }
        },
        /**
         * handle command settings dropdown
         * @param {*} command 
         * @param {*} data 
         */
        handleCommand (command, data) {
            switch (command) {
                case 'REMOVE_SET':
                    this.removeSet(data)
                break
                case 'EDIT_SET':
                    this.addSet = true
                    this.isEditSet = true
                break
            }
        },

        /**
         * remove set
         * @param {*} set 
         */
        async removeSet (set) {
            try {
                loader(this, true)
                await removeDonationSet({set_id: set._id})
                this.fetchDonatioTiersList()
            } catch (error) {
                console.error(error)
            }
            finally {
                loader(this, false)
            }
        },
        /**
         * create used for options
         */
        async fetchUsedForOptions () {
            if (!isEmpty(this.selectedValue)) {
                let domains = [];
                
                let usedForOptions = [
                    {
                        label: 'Newsroom',
                        items: [{...this.selectedValue}]
                    }
                ]
                if (this.$route.params.type === 'organisation') {
                    // api call
                    let response = await getDomainList({organisation: this.$route.params.id});
                    //update the reactive domainList data property with the newly fetched list
                    domains = response.domain || []
                    usedForOptions.push({
                        label: 'Verified domains',
                        items: domains
                    })
                }
                this.usedForOptions = usedForOptions
            }
        },

        closeAddSet () {
            this.addSet = false
            this.isEditSet = false
        },

        /**
         * change payout account
         * @param {*} value _id
         */
        changePayoutAccount (value) {
            const selectedPayoutAccount = find(this.payoutOptions, {id: value})
            this.selectedPayoutAccount = !isEmpty(selectedPayoutAccount) ? selectedPayoutAccount : {}
            this.changeDonationSet()
        },

        /**
         * change payout account
         * @param {*} value _id
         */
         changeUsedFor (value) {
            let usedFor = {}
            for(const options of this.usedForOptions) {
                const [result] = filter((options.items || []), (option) => {
                    if (value === (option.id || option._id)) return option
                })

                if (!isEmpty(result)) {
                    usedFor = result;
                    break;
                }
            }
            this.selectedUsedFor = usedFor || {}
            this.changeDonationSet()
        },

        /**
         * update donation set
         */
        changeDonationSet () {
            if (this.isEditSet) {
                // body for api
                let body = {
                    name: this.name,
                    payout_account: {
                        name: this.selectedPayoutAccount.display_name || (this.payoutAccount && this.payoutAccount.name) || '',
                        account_id: this.selectedPayoutAccount.id || this.payoutAccount && this.payoutAccount.account_id || ''
                    },
                    used_for: {
                        used_for_id: (this.selectedUsedFor.id || this.selectedUsedFor._id) || (this.usedFor && (this.usedFor.id || this.usedFor._id) ) || '',
                        name: (this.selectedUsedFor.screen_name || this.selectedUsedFor.name || this.selectedUsedFor.first_name) || (this.usedFor && (this.usedFor.screen_name || this.usedFor.name || this.usedFor.first_name)) || '',
                    }
                }
                // api call
                updateDonationSet(body, this.tierInformation._id)
                .then(() => {
                    message(this, constants.messageType.SUCCESS, 'Donation set updated successfully')
                })
            }
        },

        async querySearch(query , cb){
            //**--currently , only donation set allowed--**

                    this.tierInformationTemp={...this.tierInformation}
                    const result = await this.tierInformation && this.tierInformation.name.toLowerCase().includes(query) && this.tierInformation
                    this.searchedtierInformation={...result}
                    if(result) cb([result])
                    else cb([{name:"Not Found" ,key:"not_found"}])

            // **--if multiple donations set allowed--**

                // this.tierInformationTemp=[...this.tierInformation]
                // const result=await this.tierInformation.filter((item)=> item && item.name.toLowerCase().includes(query))
                // this.searchedtierInformation=[...result]
                // cb(result)
        },

        handleFilters (item) {
            // **-- below code will change if multiple donations allowed--**
            
            if(item && item.name==="Not Found")
                this.tierInformation=this.tierInformation;
            else{
            this.tierInformation=this.searchedtierInformation;
            }
        },
        changeOrderName () {},
        changeOrderStatus () {},
        changeOrderUsefor () {},
        changeOrderPayout () {},
        changeOrderCurrency () {},
        changePage () {}
    }
}